import { staticFile } from 'remotion';

/**
 * Ensure Cascadia Code font is loaded before Remotion renders.
 * Call with delayRender/continueRender in Remotion composition.
 */
export async function ensureFontsLoaded() {
  const regular = new FontFace(
    'Cascadia Code',
    `url(${staticFile('fonts/CascadiaCode-Regular.ttf')}) format('truetype')`,
    { weight: '400' }
  );
  const bold = new FontFace(
    'Cascadia Code',
    `url(${staticFile('fonts/CascadiaCode-Bold.ttf')}) format('truetype')`,
    { weight: '700' }
  );

  const [r, b] = await Promise.all([regular.load(), bold.load()]);
  document.fonts.add(r);
  document.fonts.add(b);
}
